import { AxiosResponse } from 'axios'
import { WebClient } from '../web-client'
import {
  SessionPayload,
  CreateSessionResponse
} from '../../interface/controllerInterface'
import { createSessionSchema } from '../../schemas/createSessionSchema'

export class OnboardingDirectorClient extends WebClient {
  /**
   * Create new session on onboarding-director API
   *
   * @param sessionPayload request body
   * @returns Axios response object
   */
  async createSession(
    sessionPayload: SessionPayload
  ): Promise<AxiosResponse<CreateSessionResponse>> {
    return this.jarvisWebHttpInstance.post({
      url: '/sessions',
      data: sessionPayload,
      validationSchema: createSessionSchema
    })
  }
}
